import {SimpleModal} from '@modules/simple-modal';
import {modals as constModals} from '@modules/constants-enumerate';

const modals = {
  [constModals.PARENT_REDEEM_CODE]: {
    resolve: () => import('../redeem-code-modal')
  },
  [constModals.SYNC_ACCOUNT]: {
    resolve: () => import('../sync-account-modal')
  },
  [constModals.SELECT_CHILD]: {
    resolve: () => import('../select-child-modal')
  },
  [constModals.CONFIRM_PARENT_ACCOUNT]: {
    resolve: () => import('../confirm-account-modal')
  },
  [constModals.LAUNCH_PRODUCT_APP]: {
    resolve: () => import('../launch-product-app-modal')
  },
  [constModals.PARENT_LESSON_DETAILS]: {
    resolve: () => import('../parent-lesson-details-modal')
  },
  [constModals.PARENT_FIRST_TIME_USER_EXPERIENCE]: {
    resolve: () => import('../parent-first-timer-user-experience-modal')
  },
};

SimpleModal.addModals(modals);
export {
  modals
};
